import { Box, Paper, Typography } from "@mui/material";

interface ActivityLog {
  date: string;
  status: string;
  by: string;
}

interface ActivityLogTableProps {
  logs: ActivityLog[];
  lastUpdated?: {date: string, by: string }
}

export default function ActivityLogTable({ logs, lastUpdated }: ActivityLogTableProps) {
  return (
    <Paper sx={{ borderRadius: "14px", boxShadow: 0, overflow: "hidden" }}>
      {/* Header */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          bgcolor: "#f8fafc",
          px: 2,
          py: 1.2,
          borderBottom: "1px solid #f0f4f8",
        }}
      >
        {["DATE", "STATUS", "BY"].map((col) => (
          <Typography
            key={col}
            sx={{ fontSize: "11px", fontWeight: 700, color: "#94a3b8", letterSpacing: 0.5 }}
          >
            {col}
          </Typography>
        ))}
      </Box>

      {/* Rows */}
      {logs.length === 0 ? (
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography sx={{ fontSize: "12px", color: "#cbd5e1" }}>
            No activity yet
          </Typography>
        </Box>
      ) : (
        logs.map((log, index) => (
          <Box
            key={index}
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              px: 2,
              py: 1.5,
              borderBottom: index < logs.length - 1 ? "1px solid #f0f4f8" : "none",
            }}
          >
            <Typography sx={{ fontSize: "12px", color: "#475569" }}>{log.date}</Typography>
            <Typography sx={{ fontSize: "12px", color: "#475569" }}>{log.status}</Typography>
            <Typography sx={{ fontSize: "12px", color: "#475569" }}>{log.by}</Typography>
          </Box>
        ))
      )}
      {lastUpdated && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2, py: 1, borderTop: "1px solid #f0f4f8" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, bgcolor: "#f8fafc", borderRadius: "20px", px: 1.5, py: 0.5 }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#94a3b8" }}>
              LAST UPDATED
            </Typography>
            <Typography sx={{ fontSize: "10px", color: "#475569" }}>
              {lastUpdated.date} by {lastUpdated.by}
            </Typography>
          </Box>
        </Box>
      )}
    </Paper>
  );
}